import { z } from 'zod';
import { createEnum } from '../../../hooks/providers/useFormHook';

export const statesList: { value: string; title: string }[] = [
  { value: 'AL', title: 'AL' },
  { value: 'AK', title: 'AK' },
  { value: 'AZ', title: 'AZ' },
  { value: 'AR', title: 'AR' },
  { value: 'CA', title: 'CA' },
  { value: 'CO', title: 'CO' },
  { value: 'CT', title: 'CT' },
  { value: 'DE', title: 'DE' },
  { value: 'FL', title: 'FL' },
  { value: 'GA', title: 'GA' },
  { value: 'HI', title: 'HI' },
  { value: 'ID', title: 'ID' },
  { value: 'IL', title: 'IL' },
  { value: 'IN', title: 'IN' },
  { value: 'IA', title: 'IA' },
  { value: 'KS', title: 'KS' },
  { value: 'KY', title: 'KY' },
  { value: 'LA', title: 'LA' },
  { value: 'ME', title: 'ME' },
  { value: 'MD', title: 'MD' },
  { value: 'MA', title: 'MA' },
  { value: 'MI', title: 'MI' },
  { value: 'MN', title: 'MN' },
  { value: 'MS', title: 'MS' },
  { value: 'MO', title: 'MO' },
  { value: 'MT', title: 'MT' },
  { value: 'NE', title: 'NE' },
  { value: 'NV', title: 'NV' },
  { value: 'NH', title: 'NH' },
  { value: 'NJ', title: 'NJ' },
  { value: 'NM', title: 'NM' },
  { value: 'NY', title: 'NY' },
  { value: 'NC', title: 'NC' },
  { value: 'ND', title: 'ND' },
  { value: 'OH', title: 'OH' },
  { value: 'OK', title: 'OK' },
  { value: 'OR', title: 'OR' },
  { value: 'PA', title: 'PA' },
  { value: 'RI', title: 'RI' },
  { value: 'SC', title: 'SC' },
  { value: 'SD', title: 'SD' },
  { value: 'TN', title: 'TN' },
  { value: 'TX', title: 'TX' },
  { value: 'UT', title: 'UT' },
  { value: 'VT', title: 'VT' },
  { value: 'VA', title: 'VA' },
  { value: 'WA', title: 'WA' },
  { value: 'WV', title: 'WV' },
  { value: 'WI', title: 'WI' },
  { value: 'WY', title: 'WY' },
];

export const createSchema = (t?: any) => {
  let zipError = 'Zip code must be between 5 and 7 characters';
  let streetError = 'Street is required';
  let stateError = 'State is required';
  let cityError = 'Please enter a valid city';
  const aptError = 'can\'t be more than 40 characters';
  if (t) {
    zipError = t('CHANGE_ADDRESS.ERRORS.zip.description');
    streetError = t('CHANGE_ADDRESS.ERRORS.street.description');
    stateError = t('CHANGE_ADDRESS.ERRORS.state.description');
    cityError = t('CHANGE_ADDRESS.ERRORS.city.description');
  }
  return z.object({
    street: z.string().describe('street').min(1, streetError),
    apt: z.string().max(40, aptError).describe('apt').optional(),
    city: z.string().describe('city').min(1, cityError),
    zip: z.string().describe('zip').min(5, zipError).max(5, zipError),
    state: z
      .enum(statesList.map((state) => state.value) as [string, ...string[]])
      .describe('state')
      .refine((val) => val !== '', {
        message: stateError,
      }),
  });
};

const changePersonalAddressSchema = createSchema();

export type ChangePersonalAddressType = z.infer<typeof changePersonalAddressSchema>;

export type ChangePersonalAddressKeys = keyof z.infer<typeof changePersonalAddressSchema>;

// Create the enum using the extracted keys
export const ChangePersonalAddressEnum = createEnum(
  Object.keys(changePersonalAddressSchema.shape) as ChangePersonalAddressKeys[],
);
